<template>
  <div>
    <ul>
      <project-item
        v-for="(project, i) in projects"
        v-bind="{ ...project }"
        :key="`project-${i}`"
      />
    </ul>

    <p v-if="showAttr" id="attr" class="mt-16">
      <a
        href="https://designbycosmic.com"
        class="link-basic text-xs italic"
        :class="{
          blink: blink
        }"
      >
        <sup>*</sup> Used with permission from Design by Cosmic, Inc.
      </a>
    </p>
  </div>
</template>

<script>
import ProjectItem from "./Item";

/**
 * @name Project List
 * @description outputs array of provided projects
 * @vue-prop {boolean} blink - When true the project attribution at the bottom of the list will blink. Default = false.
 * @vue-prop {boolean} showAttr - When true the project attribution at the bottom of the list will display. Default = false.
 * @vue-prop {array} projects
 * @example <project-list :projects="projects" :showAttr="true" :blink="blinkAttr" />
 */
export default {
  components: {
    ProjectItem
  },
  props: {
    blink: Boolean,
    showAttr: Boolean,
    projects: Array
  }
};
</script>

<style lang="scss" scoped>
.blink {
  animation: 0.5s blinker linear 5;
}

@keyframes blinker {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
